import {IApiLeagueRestriction} from "../../typings/apiResponse";

export class LeagueRestriction {
    constructor(protected apiData: IApiLeagueRestriction) {}

    public getPassedMembers(): number[] {
        return this.apiData.passedMembers;
    }

    public getFailedMembers(): {[key: string]: any}[] {
        return this.apiData.failedMembers;
    }

    /**
     * Returns the minimum of members in a team that needs to pass the restriction
     * @returns {number}
     */
    public getMinMembers(): number {
        if (!this.apiData.params) {
            return undefined;
        }

        return this.apiData.params.minmembers;
    }

    /**
     * Returns the raw object of the restriction params
     * @returns {any}
     */
    public getParams(): any {
        return this.apiData.params;
    }

    /**
     * Returns the restriction type
     * @returns {string}
     */
    public getType(): string {
        return this.apiData.type;
    }

    /**
     * Returns if a contestant has passed the restriction test
     * @returns {boolean}
     */
    public hasPassed(): boolean {
        return this.apiData.passed;
    }

    /**
     * @returns until as Date object if until exists, else null.
     */
    public getUntil(): Date|null {
        return this.apiData.until ? new Date(this.apiData.until) : null;
    }
}